module.exports = __webpack_public_path__ + "img/ic_benifit_chollege.9adb0f33.png";